import { render, staticRenderFns } from "./longAssociation.vue?vue&type=template&id=29a2b4c8&scoped=true&"
import script from "./longAssociation.vue?vue&type=script&lang=js&"
export * from "./longAssociation.vue?vue&type=script&lang=js&"
import style0 from "./longAssociation.vue?vue&type=style&index=0&id=29a2b4c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2b4c8",
  null
  
)

export default component.exports